import { useProgress } from "@devowl-wp/real-queue";
import { useCallback } from "react";
import { useStores } from "../store";
import { SCAN_QUEUE_JOB } from "../types";
/**
 * Returns the status / progress of the scanner.
 */ function useScannerProgress(fetchStatusInterval, fetchAdditionalData, onCancel) {
    if (fetchAdditionalData === void 0) fetchAdditionalData = false;
    const { scannerStore } = useStores();
    return useProgress({
        type: SCAN_QUEUE_JOB,
        fetchStatusInterval,
        fetchAdditionalData,
        onAdditionalData: useCallback((param)=>{
            let { "rcb-scan-list": rcbScanList } = param;
            const { templates, externalUrls } = rcbScanList;
            scannerStore.resultTemplatesFromResponse(templates);
            scannerStore.resultExternalUrlsFromResponse(externalUrls);
        }, [
            scannerStore
        ]),
        onCancel
    });
}
export { useScannerProgress };
